import { request } from "./request"

export default {
  /**
   * 获取用户别称
   * @param {*} Token 
   * @returns 
   */
  UserNickName(Token) {
    return request({
      url: `/GetUserNickName/${Token
        }`,
      method: "get",
    })
  },
  /**
   * 当前用户是否是SalesAdmin
   */
  bIsSalesAdmin() {
    return request({
      url: "/UserProfile/bIsSalesAdmin",
      method: "get",

    })
  },
  /**
  * 获取当前用户信息
  */
  GetUserInfo() {
    return request({
      url: "/UserProfile/GetUserInfo",
      method: "get",

    })
  },
  /**
* 获取用户列表
*/
  GetUserList(search) {
    return request({
      url: "/UserProfile/GetUserList",
      method: "post",
      data: search
    })
  },
  /**
* 获取用户列表
*/
  GetUserList2(search) {
    return request({
      url: "/UserProfile/GetUserList3",
      method: "post",
      data: search
    })
  },
  /**
 * 修改用户密码
 */
  UpdateUserPassword(search) {
    return request({
      url: "/UserProfile/UpdateUserPassword",
      method: "post",
      data: search
    })
  },
  /**
  * 修改用户信息
  */
  UpdateUserInfo(search) {
    return request({
      url: "/UserProfile/UpdateUserInfo",
      method: "post",
      data: search
    })
  },
  /**
  * 修改KeyAccount
  */
  UpdateKeyAccount(search) {
    return request({
      url: "/UserProfile/UpdateKeyAccount",
      method: "post",
      data: search
    })
  },
  /**
* 获取团队列表
*/
  GetTeamsList(search) {
    return request({
      url: "/UserProfile/GetTeamsList",
      method: "post",
      data: search
    })
  },
  /**
* 添加Teams
*/
  AddTeams(search) {
    return request({
      url: "/UserProfile/AddTeams",
      method: "post",
      data: search
    })
  },
  /**
* 修改Teams
*/
  UpdateTeams(search) {
    return request({
      url: "/UserProfile/UpdateTeams",
      method: "post",
      data: search
    })
  },
  /**
* 删除Teams
*/
  DeleteTeams(search) {
    return request({
      url: "/UserProfile/DeleteTeams",
      method: "post",
      data: search
    })
  },
  /**
  * 获取Groups列表
  */
  GetGroupsList(search) {
    return request({
      url: "/UserProfile/GetGroupsList",
      method: "post",
      data: search
    })
  },
  /**
  * 添加Groups
  */
  AddGroups(search) {
    return request({
      url: "/UserProfile/AddGroups",
      method: "post",
      data: search
    })
  },
  /**
  * 修改Groups
  */
  UpdateGroups(search) {
    return request({
      url: "/UserProfile/UpdateGroups",
      method: "post",
      data: search
    })
  },
  /**
* 删除Groups
*/
  DeleteGroups(search) {
    return request({
      url: "/UserProfile/DeleteGroups",
      method: "post",
      data: search
    })
  },
  /**
* 获取Functions列表
*/
  GetFunctionsList(search) {
    return request({
      url: "/UserProfile/GetFunctionsList",
      method: "post",
      data: search
    })
  },
  /**
* 添加权限名称
*/
  AddFunctions(search) {
    return request({
      url: "/UserProfile/AddFunctions",
      method: "post",
      data: search
    })
  },
  /**
* 修改权限名称
*/
  UpdateFunctions(search) {
    return request({
      url: "/UserProfile/UpdateFunctions",
      method: "post",
      data: search
    })
  },
  /**
* 获取Roles列表
*/
  GetRolesList(search) {
    return request({
      url: "/UserProfile/GetRolesList",
      method: "post",
      data: search
    })
  },
  /**
* 添加Roles
*/
  AddRoles(search) {
    return request({
      url: "/UserProfile/AddRoles",
      method: "post",
      data: search
    })
  },
  /**
* 修改Roles
*/
  UpdateRoles(search) {
    return request({
      url: "/UserProfile/UpdateRoles",
      method: "post",
      data: search
    })
  },
  /**
* Add RolesFunctions
*/
  AddRolesFunctions(search) {
    return request({
      url: "/UserProfile/AddRolesFunctions",
      method: "post",
      data: search
    })
  },
  /**
* Update RolesFunctions
*/
  UpdateRolesFunctions(search) {
    return request({
      url: "/UserProfile/UpdateRolesFunctions",
      method: "post",
      data: search
    })
  },
  /**
* Add UsersRoles
*/
  AddUsersRoles(search) {
    return request({
      url: "/UserProfile/AddUsersRoles",
      method: "post",
      data: search
    })
  },

  /**
* Update UsersRoles
*/
  UpdateUsersRoles(search) {
    return request({
      url: "/UserProfile/UpdateUsersRoles",
      method: "post",
      data: search
    })
  },

  /**
   * 获取配置列表
   */
  GetConfigList(search) {
    return request({
      url: "/UserProfile/GetConfigList",
      method: "post",
      data: search
    })
  },
  /**
  * 添加修改配置
  */
  AddUpdateConfig(search) {
    return request({
      url: "/UserProfile/AddUpdateConfig",
      method: "post",
      data: search
    })
  },

  /**
  * 删除配置
  */
  DeleteConfig(search) {
    return request({
      url: "/UserProfile/DeleteConfig",
      method: "post",
      data: search
    })
  },
  /**
  * 刷新缓存
  */
  ResetConfig(search) {
    return request({
      url: "/UserProfile/ResetConfig",
      method: "post",
      data: search
    })
  },
  /**
   * 获取数据推送金蝶结果列表
   */
  GetEASSendDataList(search) {
    return request({
      url: "/UserProfile/GetEASSendDataList",
      method: "post",
      data: search
    })
  },
  /**
   * 重启任务
   */
  ResetScheduleEAS() {
    return request({
      url: "/UserProfile/ResetScheduleEAS",
      method: "get",
    })
  },
  /**
   * 停止任务
   */
  StopScheduleEAS() {
    return request({
      url: "/UserProfile/StopScheduleEAS",
      method: "get",
    })
  },
  /**
   * 数据推送到金蝶
   */
  PushDataToEAS(ContractNo) {
    return request({
      url: "/UserProfile/PushDataToEAS",
      method: "post",
      data: ContractNo
    })
  },
  /**
   * 范围日期数据推送到金蝶
   */
  PushDateDataToEAS(data) {
    return request({
      url: "/UserProfile/PushDateDataToEAS",
      method: "post",
      data: data
    })
  },
  /**
 * 客户推送到金蝶
 */
  PushAdvertiserToEAS(data) {
    return request({
      url: "/UserProfile/PushAdvertiserToEAS",
      method: "post",
      data: data
    })
  },
  /**
 * 发票数据推送到金蝶
 */
  PushDataToEASInvoice(InvoiceNumber) {
    return request({
      url: "/UserProfile/PushDataToEASInvoice",
      method: "post",
      data: InvoiceNumber
    })
  },
  /**
* 范围日期发票数据推送到金蝶
*/
  PushDateDataInvoiceToEAS(data) {
    return request({
      url: "/UserProfile/PushDateDataInvoiceToEAS",
      method: "post",
      data: data
    })
  },

  /**
* 获取EASAdvertiser列表
*/
  GetEASAdvertiserList(search) {
    return request({
      url: "/UserProfile/GetEASAdvertiserList",
      method: "post",
      data: search
    })
  },
  /**
  * 添加修改EASAdvertiser
  */
  AddUpdateEASAdvertiser(search) {
    return request({
      url: "/UserProfile/AddUpdateEASAdvertiser",
      method: "post",
      data: search
    })
  },

  /**
  * 删除EASAdvertiser
  */
  DeleteEASAdvertiser(search) {
    return request({
      url: "/UserProfile/DeleteEASAdvertiser",
      method: "post",
      data: search
    })
  },
  /**
  * 查询返回客户数据列表
  */
  GetAdvertiserListInEAS(search) {
    return request({
      url: "/UserProfile/GetAdvertiserListInEAS",
      method: "post",
      data: search
    })
  },
   /**
 * Finance查询合同/发票数据
 */
   GetEASSendDataListFinance(search) {
    return request({
      url: "/UserProfile/GetEASSendDataListFinance",
      method: "post",
      data: search
    })
  },
  /**
*  Finance多选择推送合同/发票
*/
  PushContractInvoiceDataToEASFinance(search) {
    return request({
      url: "/UserProfile/PushContractInvoiceDataToEASFinance",
      method: "post",
      data: search
    })
  },
  /**
* Fixed Conttract/Invoice
*/
FixedConttractInvoiceFinance(search) {
    return request({
      url: "/UserProfile/FixedConttractInvoiceFinance",
      method: "post",
      data: search
    })
  },
}
